// extracted by mini-css-extract-plugin
module.exports = {"Newsletter__label":"wvsF","Newsletter__title":"KsNO","Newsletter__subtitle":"oB7j","Newsletter__root":"Us_J"};